import React from "react";

class JumpTabList extends React.PureComponent {
  render() {
    const {
      tabs,
      customeButton = "border rounded border-gray-200 px-2 py-1 text-gray-800 hover:border-blue-400",
    } = this.props;

    const options = tabs.map((tab) => {
      if (typeof tab === "string") {
        return { value: tab, label: tab };
      }
      return {
        value: tab.key || tab.value,
        label: tab.title || tab.label || tab.name,
      };
    });

    return (
      <div className="mb-4 flex flex-wrap items-center gap-1 text-sm">
        <div className="font-semibold text-gray-700">Jump to: </div>
        {options.map((opt) => {
          return (
            <button
              key={opt.value}
              type="button"
              className={customeButton}
              onClick={() => {
                document.getElementById(opt.value).scrollIntoView();
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    );
  }
}

export default JumpTabList;
